<!-- 发票类型 -->
<template>
  <div class="invoice-type">
    <BaseSelect 
      v-if="uiType === 'select'" 
      placeholder="请选择"
      width="100%"
      v-model="val" 
      @change="handleEmit"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </BaseSelect>
    <BaseRadioGroup 
      v-else
      v-model="val" 
      @change="handleEmit"
    >
      <el-radio-button
        v-for="item in options"
        :key="item.value"
        :label="item.value"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup>
    <span slot="other" class="invoice-type__amount">
      <template v-if="amount">
        税费：￥{{ amount.toFixed(2) }}
      </template>
    </span>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    invoice_kind: {
      type: [String, Number],
      default: ''
    },
    // pcbQuote-PCB计价页 smtQuote-SMT计价页 pcbSubmit-PCB提交页 smtSubmit-SMT提交页
    pageType: {
      type: String,
      default: 'pcbQuote',
      validator: function (value) {
        return ['pcbQuote', 'smtQuote', 'pcbSubmit', 'smtSubmit'].includes(value)
      }
    },
    uiType: {
      type: String,
      default: 'radio',
      validator: function (value) {
        return ['radio', 'select'].includes(value)
      }
    },
    amount: {
      type: [String, Number],
      default: 0
    },
  },
  data() {
    return {
      val: this.value,
    }
  },
  computed: {
    options() {
      // PCB计价页
      if (this.pageType === 'pcbQuote') {
        return [
          { value: '普票-个人', label: ' 数电增值税（普通）发票-个人' },
          { value: '普票-公司', label: ' 数电增值税（普通）发票-公司' },
          { value: '增票全电', label: '数电增值税（专用）发票' }
        ]
      }
      return [
        { value: '普票', label: '数电增值税（普通）发票' },
        { value: '增票全电', label: '数电增值税（专用）发票' }
      ]
    }
  },
  watch: {
    value(newVal) {
      // PCB计价页需要区分 普票-个人 和 普票-公司
      if (this.pageType === 'pcbQuote' && newVal === '普票') {
        this.val = { 2: '普票-个人', 1: '普票-公司' }[this.invoice_kind]
      } else {
        this.val = newVal
      }
    }
  },
  created() {
    this.validVal()
  },
  methods: {
    handleEmit() {
      const val = { '普票-个人': '普票', '普票-公司': '普票' }[this.val] || this.val
      const invoice_kind = this.val === '普票-个人' ? 2 : 1
      this.$emit('input', val)
      this.$emit('change', val, invoice_kind)
    },
    validVal() {
      const { val, pageType } = this
      if (!val && pageType !== 'pcbQuote') {
        this.val = '增票全电'
        this.handleEmit()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice-type {
  .invoice-type__amount {
    margin-left: 10px;
  }
}
</style>